/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { useEffect, useState } from "react";
import Input from "../../components/Input";
import { useForm } from "react-hook-form";
import {
  useFetchCountriesAllData,
  useFetchCountryCitiesAllData,
} from "../../apis/locationApis";
import {
  useCreateCoverageMutation,
  useCreateWarehouseMutation,
  useWarehouseListData,
} from "../../apis/warehouseApi";
import toast from "react-hot-toast";
import { useProfileData } from "../../apis/profileApis";
import { useNavigate } from "react-router-dom";
import WarehouseAddressPicker from "../Warehouse/_components/WarehouseAddressPicker";
import { IconLogout } from "@tabler/icons-react";
import { fetch3 } from "../../commonApis/commonApis";
import { useDispatch } from "react-redux";
import { logout } from "../../features/auth/authSlice";
import { useQueryClient } from "@tanstack/react-query";

type FormValues = {
  name: string;
  location: string;
  country: string;
  district: string;
  zipCode: string;
  city: string;
  shortAddress?: string;
  latitude?: string;
  longitude?: string;
  status?: boolean;
};

type CoverageFormValues = {
  warehouseId: string;
  covrageCountry: string;
  covrageName: string;
  covrageCities: string[];
  status?: boolean;
};

export default function CreateWarehouse() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const queryClient = useQueryClient();
  const [step, setStep] = useState(1);
  const [isLoggingOut, setIsLoggingOut] = useState(false);
  const [mode, setMode] = useState("country");
  const [selectedCountry, setSelectedCountry] = useState<any>();
  const [selectedWarehouse, setSelectedWarehouse] = useState<any>();
  const [city, setCity] = useState<any>();
  const [cities, setCities] = useState<any>([]);
  const [district, setDistrict] = useState<any>(null);
  const [selectedCoverageCountry, setSelectedCoverageCountry] = useState<any[]>(
    []
  );
  const [error, setError] = useState<string>("");
  const [selectedCitiesArray, setSelectedCitiesArray] = useState<any>();
  const [checked, setChecked] = useState<boolean>(false);
  const { data } = useFetchCountriesAllData();
  const { data: citiesData, refetch: countryRefetch } =
    useFetchCountryCitiesAllData(selectedCountry?.id);
  const { data: coverageCitiesData, refetch: coverageCityRefetch } =
    useFetchCountryCitiesAllData(
      (selectedCoverageCountry?.length > 0 && selectedCoverageCountry[0]) ??
        data?.covrageCountry
    );
  const { mutate, isPending } = useCreateWarehouseMutation();
  const { mutate: coverageMutate, isPending: coveragePending } =
    useCreateCoverageMutation();
  const { refetch } = useWarehouseListData();
  const { refetch: profileFetch, data: profileData } = useProfileData();
  const {
    register,
    handleSubmit,
    clearErrors,
    reset,
    setValue,
    control,
    formState: { errors },
  } = useForm<FormValues>();

  const {
    register: coverageRegister,
    handleSubmit: coverageSubmit,
    clearErrors: coverageClearErrors,
    reset: coverageReset,
    watch: coverageWatch,
    formState: { errors: coverageErrors },
  } = useForm<CoverageFormValues>();

  useEffect(() => {
    setCities(citiesData);
  }, [citiesData]);

  useEffect(() => {
    if (profileData?.isWarehouseCreated) {
      navigate("/orders");
    }
  }, [profileData]);

  useEffect(() => {
    if (selectedCoverageCountry?.length > 0) {
      coverageCityRefetch();
    }
  }, [selectedCoverageCountry]);


  const handleContinue = (data: FormValues) => {
    mutate(
      {
        ...data,
        country: selectedCountry?.id,
        city: city?.id || data.city,
        district: district?.id || data.district,
      },
      {
        onSuccess: (data) => {
          reset();
          setCities([]);
          refetch();
          profileFetch();
        },
        onError: (error) => {
          console.log(error, "error");
          toast.error(`${error}`);
        },
      }
    );
  };

  const handleCreate = (formData: CoverageFormValues) => {
    if (
      selectedCoverageCountry?.length < 2 &&
      selectedCitiesArray?.length === 0
    ) {
      setError("Please select minimum one city");
      return;
    } else {
      setError("");
    }
    let countries = data
      ?.filter((e: any) => selectedCoverageCountry?.includes(e?.name))
      .map((v: any) => {
        return {
          countryName: v?.name,
          countryId: v?.id,
          covrageCities:
            selectedCoverageCountry?.length === 1 ? selectedCitiesArray : [],
        };
      });
    coverageMutate(
      {
        ...formData,
        covrage: countries,
        warehouseId: selectedWarehouse?.id,
      },
      {
        onSuccess: (data) => {
          profileFetch();
        },
        onError: (error) => {
          console.log(error, "error");
          toast.error(`${error}`);
        },
      }
    );
  };

  useEffect(() => {
    profileFetch();
  }, []);
  useEffect(() => {
    if (selectedCountry?.id) {
      countryRefetch();
    }
  }, [selectedCountry]);

  const handleLogout = async () => {
    if (isLoggingOut) return;

    setIsLoggingOut(true);
    try {
      await fetch3(
        `${process.env.REACT_APP_BASE_URL}/api/auth/logout?type=client`,
        "get"
      );
      queryClient.clear();
      dispatch(logout());
      await profileFetch();
      navigate("/", { replace: true });
    } catch (error: any) {
      toast.error(error?.message ?? "Unable to logout. Please try again.");
    } finally {
      setIsLoggingOut(false);
    }
  };

  return (
    <div className="flex items-center justify-center py-10 text-[#1E293B]">
      <div className="w-11/12 max-w-3xl mx-auto bg-gradient-to-r from-[#FFFFFD] to-[#FDF8E5] rounded-3xl p-6 shadow-xl">
        <div className="mb-6 flex items-center justify-between gap-4 border-b border-[#E8DFC1] pb-4">
          <img
            src="/img/logo-tracktech-black.svg"
            alt="Tracktech logo"
            className="w-full max-w-[180px]"
          />
          <button
            type="button"
            onClick={handleLogout}
            disabled={isLoggingOut}
            className="inline-flex shrink-0 items-center justify-center gap-2 rounded-full border border-[#E5C044] bg-[#FBD037] px-4 py-2 text-sm font-medium text-[#1E293B] transition-colors hover:bg-yellow-400 disabled:cursor-not-allowed disabled:opacity-60"
            aria-label="Logout"
          >
            {isLoggingOut ? (
              <span className="h-4 w-4 animate-spin rounded-full border-2 border-[#1E293B]/30 border-t-[#1E293B]" />
            ) : (
              <IconLogout size={18} stroke={1.8} />
            )}
            <span>{isLoggingOut ? "Logging out..." : "Logout"}</span>
          </button>
        </div>
        <div className="space-y-6">
          <div className="space-y-2">
            <h1 className="text-3xl font-medium text-center">
              Create Warehouse
            </h1>
            <p className="text-sm text-[#000000]  text-center">
              Please fill the form below !
            </p>
          </div>
          <div className="grid grid-cols-4 gap-4">
            <Input
              name="name"
              className="col-span-4"
              type="text"
              title="Warehouse Name"
              placeholder="Main Riyadh "
              other={{
                className:
                  "w-full space-y-1 px-4 py-2 text-sm rounded-full outline-none bg-white border border-[#D8D8D8] focus:border-[#4F6EF7]",
              }}
              register={register}
              error={errors?.name}
              validation={{
                required: "Warehouse name is required",
                pattern: {
                  value: /^(?=.*[A-Za-z\u0600-\u06FF])[A-Za-z\u0600-\u06FF0-9\s-]+$/,
                  message:
                    "Warehouse Name must include at least one letter (not only numbers)",
                },
                validate: (value: string) => {
                  const trimmed = value.trim();
                  if (trimmed.length < 3)
                    return "Warehouse name must be at least 3 characters";
                  if (trimmed.length > 30)
                    return "Warehouse name must be at most 30 characters";
                  if (!value?.trim())
                    return "Warehouse Name cannot be empty or only spaces";
                  return true;
                },
              }}
            />

            <WarehouseAddressPicker
              register={register}
              errors={errors}
              setValue={setValue}
              control={control}
              clearErrors={clearErrors}
              countries={data || []}
              cities={citiesData || []}
              selectedCountry={selectedCountry}
              selectedCity={city}
              selectedDistrict={district}
              onCountryChange={setSelectedCountry}
              onCityChange={setCity}
              onDistrictChange={setDistrict}
            />
            <div className="pt-4  col-span-4">
              <button
                onClick={handleSubmit(handleContinue)}
                disabled={isPending} // disable when loading
                className={`w-full flex justify-center text-sm font-medium rounded-full py-3 gap-2 ${
                  isPending
                    ? "bg-gray-800 cursor-not-allowed text-[#ffffff]"
                    : "bg-[#FBD037] hover:bg-yellow-400 text-[#000000]"
                }`}
              >
                {isPending ? (
                  <>
                    <svg
                      className="animate-spin h-5 w-5 text-white"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                    >
                      <circle
                        className="opacity-25"
                        cx="12"
                        cy="12"
                        r="10"
                        stroke="currentColor"
                        strokeWidth="4"
                      />
                      <path
                        className="opacity-75"
                        fill="currentColor"
                        d="M4 12a8 8 0 018-8v4l3-3-3-3v4a8 8 0 000 16z"
                      />
                    </svg>
                    Submitting...
                  </>
                ) : (
                  "Submit"
                )}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
